import { IWorkflowRunSteps } from 'interface/workflowInterface';
import { HeadCell } from 'components/common/TableCommon';
import { ReactComponent as LogsIcon } from 'assets/icons/logs.svg';

export const createHeadCellList = (
  onFetchLogs: (_stepId: string) => void,
): HeadCell<IWorkflowRunSteps>[] => [
  {
    id: 'name',
    label: 'Name',
    hide: false,
    cellRender: row => {
      return <>{row?.Name}</>;
    },
  },
  {
    id: 'status',
    label: 'Status',
    hide: false,
    cellRender: row => {
      return <>{row?.Status}</>;
    },
  },
  {
    id: 'startedAt',
    label: 'Started At',
    hide: false,
    cellRender: row => {
      return <>{new Date(row?.StartedAt).toLocaleString()}</>;
    },
  },
  {
    id: 'finishedAt',
    label: 'Finished At',
    hide: false,
    cellRender: row => {
      return <>{new Date(row?.FinishedAt).toLocaleString()}</>;
    },
  },
  {
    id: 'nextStepIds',
    label: 'Next Step IDs',
    hide: false,
    cellRender: row => {
      return <>{row?.NextStepIDs.join(', ') || 'None'}</>;
    },
  },
  {
    id: 'logs',
    label: 'Logs',
    hide: false,
    cellRender: row => {
      return (
        <div className="action-buttons">
          {row?.GCSLogPath && (
            <LogsIcon
              className="cursor-pointer"
              onClick={() => onFetchLogs(row.ID)}
            />
          )}
        </div>
      );
    },
  },
];
